module.exports = ""


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards-activation/credit/credit.component.html
// module id = ../../../../../src/app/master/cards-activation/credit/credit.component.html
// module chunks = main